var _linearGradient, _linearGradient2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgLamp2 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 206 386.5",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "555cfed5-d90b-480d-8ebe-403b0e886f67"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 67.6,
    width: 4.1,
    height: 213.3,
    style: {
      fill: "none"
    }
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_35",
    "data-name": "Sfumatura senza nome 35",
    x1: -200.29,
    y1: -958.38,
    x2: -196.68,
    y2: -958.38,
    gradientTransform: "translate(328.37 1262.2) scale(1.14)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6f7373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#757871"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "7a28e3c6-492c-4478-bfc0-416f7f182306"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206,379.1c0,6.5-46.1,7.4-103,7.4S0,385.6,0,379.1s46.1-74.7,103-74.7S206,372.6,206,379.1Z",
    style: {
      fill: "none"
    }
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_36",
    "data-name": "Sfumatura senza nome 36",
    x1: 1721.95,
    y1: -852.74,
    x2: 1725.56,
    y2: -852.74,
    gradientTransform: "translate(29361.74 -57666.75) rotate(143.07) scale(33.79)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#585b5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2f2f2f"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "g4934"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#555cfed5-d90b-480d-8ebe-403b0e886f67)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4936"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4948",
    d: "M101,280.9h4.1V67.6H101V280.9",
    style: {
      fill: "url(#Sfumatura_senza_nome_35)"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    id: "path4950",
    d: "M114,49.2H92.1V0H114V49.2",
    style: {
      fill: "#2f2f2f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4952",
    d: "M103.1,73.8h-.2c0,.4-10.8-4.9-10.8-10.8V49.2H114V63c0,5.9-10.9,10.8-10.9,10.8",
    style: {
      fill: "#1b1a1a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4954",
    d: "M114,311.7V279.8H92.1v31.9H114",
    style: {
      fill: "#2f2f2f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4956",
    d: "M102.9,255.2h.2c0-.4,10.8,4.8,10.8,10.8v13.8H92V266c.1-6,10.9-10.8,10.9-10.8",
    style: {
      fill: "#1b1a1a"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g4958"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#7a28e3c6-492c-4478-bfc0-416f7f182306)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4960"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4972",
    d: "M206,379.1c0,6.5-46.1,7.4-103,7.4S0,385.6,0,379.1s46.1-74.7,103-74.7,103,68.2,103,74.7",
    style: {
      fill: "url(#Sfumatura_senza_nome_36)"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    id: "path4974",
    d: "M206,379.8c0,3.7-46.1,6.7-103,6.7s-103-3-103-6.7,46.1-6.7,103-6.7,103,3,103,6.7",
    style: {
      fill: "#686b6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4976",
    d: "M200.7,380.6c0,2.9-43.7,5.2-97.7,5.2s-97.7-2.3-97.7-5.2,43.7-5.2,97.7-5.2,97.7,2.3,97.7,5.2",
    style: {
      fill: "#fffdf5"
    }
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLamp2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/lamp2.f4650bc7d0069dd995d400b24591b10a.svg";